import { createApp, watch } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { useTenantConfig } from './composables/useTenantConfig'
import { resolveInitialLocale, readUrlLang, readBrowserLangs } from './utils/locale'

async function init() {
    // Fetch tenant config before mounting so theme + meta are ready on first render
    const { config, fetchConfig } = useTenantConfig()
    await fetchConfig()

    // The tenant's default customer language (back office) overrides browser detection;
    // a ?lang= link still wins. Applied before mount, so there is no flash of another language.
    i18n.global.locale.value = resolveInitialLocale({
        urlLang: readUrlLang(),
        tenantDefault: config.value?.defaultLanguage ?? null,
        browserLangs: readBrowserLangs()
    })

    // Keep <html lang> in step with the rendered language (incl. the header switcher)
    document.documentElement.lang = i18n.global.locale.value
    watch(i18n.global.locale, (lang) => { document.documentElement.lang = lang || 'en' })

    createApp(App).use(i18n).mount('#app')
}

init()
